export class NotFoundError<R = unknown> extends Error {
  constructor(public data?: R) {
    super();
  }
}
